import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "kuran_visitor_id";

// Získa alebo vytvorí trvalé anonymné ID návštevníka (bez cookies, len localStorage).
const getVisitorId = () => {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) ||
        `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return `v-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

// Zaznamená jednu návštevu na načítanie aplikácie.
const useVisitTracker = () => {
  useEffect(() => {
    const visitor_id = getVisitorId();
    axios
      .post(`${API}/visit`, { visitor_id, path: window.location.pathname })
      .catch(() => {});
  }, []);
};

export default useVisitTracker;
